'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateBoundingBox = exports.ctaClick = exports.nearbyVenuesKey = exports.loadVenues = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _toArray2 = require('babel-runtime/helpers/toArray');

var _toArray3 = _interopRequireDefault(_toArray2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.filterValidVenues = filterValidVenues;
exports.doCtaNavigation = doCtaNavigation;
exports.getNearbyPopularVenues = getNearbyPopularVenues;
exports.doLoadVenues = doLoadVenues;
exports.watchSaga = watchSaga;

var _bound = require('redux/saga/entities/bound');

var _sagaTools = require('@classpass/saga-tools');

var _effects = require('redux-saga/effects');

var _reactRouterRedux = require('react-router-redux');

var _universalLogger = require('universal-logger');

var logger = _interopRequireWildcard(_universalLogger);

var _verify = require('helpers/verify');

var _explore = require('redux/modules/features/explore');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(doCtaNavigation),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(getNearbyPopularVenues),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(doLoadVenues),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(watchSaga); /* globals L: true */

var MAX_VENUES = 50;
var MIN_VENUES = 10;
var MIN_RATING = 0;
var RADIUS_ATTEMPTS = [1, 5, 10, 30];

var LOAD_VENUE_DATA = 'cmsPage/modules/Experimental/ExploreMap/ExploreMapV1/LOAD_VENUE_DATA';

var loadVenues = exports.loadVenues = function loadVenues(location) {
  return (0, _extends3.default)({ type: LOAD_VENUE_DATA }, location);
};

var nearbyVenuesKey = exports.nearbyVenuesKey = function nearbyVenuesKey(location) {
  return location && 'explore-map-v1-venues-near-' + location.lat + '-' + location.lon;
};

function filterValidVenues(venues) {
  try {
    return venues.filter(function (_ref) {
      var _ref$ratings = _ref.ratings,
          total = _ref$ratings.count.total,
          mean = _ref$ratings.mean;
      return mean >= MIN_RATING || total === 0;
    });
  } catch (error) {
    return [];
  }
}

var ctaClick = exports.ctaClick = function ctaClick() {
  return { type: 'EXPERIMENT_EXPLORE_MAP_V1_CTA_CLICK', experiment: 'Explore-map-v1' };
};

function doCtaNavigation() {
  return _regenerator2.default.wrap(function doCtaNavigation$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.put)((0, _reactRouterRedux.push)('/explore'));

        case 2:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

/* istanbul ignore-next */
var calculateBoundingBox = exports.calculateBoundingBox = function calculateBoundingBox(venues) {
  var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      latitude = _ref2.latitude,
      longitude = _ref2.longitude;

  var venuesInView = (venues || []).map(function (venue) {
    return [venue.location.lat, venue.location.lon];
  });

  if (venuesInView.length) {
    var bBoxString = void 0;
    try {
      bBoxString = L.latLngBounds(venuesInView).toBBoxString();
    } catch (err) {/* noop */}

    var _split = (bBoxString || '').split(','),
        _split2 = (0, _slicedToArray3.default)(_split, 4),
        southwestLng = _split2[0],
        southwestLat = _split2[1],
        northeastLng = _split2[2],
        northeastLat = _split2[3];

    if (southwestLat && southwestLng && northeastLat && northeastLng) {
      return southwestLat + ',' + southwestLng + ',' + northeastLat + ',' + northeastLng;
    }
  }

  // If there weren't any venues in the zip, or we couldn't generate
  // bounds for some reason, we return the default lat/long pairs here.
  if (latitude && longitude) {
    return latitude + ',' + longitude + ',' + latitude + ',' + longitude;
  }

  return null;
};

function getNearbyPopularVenues(client, location, radii) {
  var key, _radii, _radii2, radius, nextRadii, _ref3, venues, boundingBox, validVenueCount;

  return _regenerator2.default.wrap(function getNearbyPopularVenues$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          if ((0, _verify.isAbsent)(radii)) {
            radii = RADIUS_ATTEMPTS;
          }

          key = nearbyVenuesKey(location);
          _radii = radii, _radii2 = (0, _toArray3.default)(_radii), radius = _radii2[0], nextRadii = _radii2.slice(1);

          if (!(0, _verify.isAbsent)(radius)) {
            _context2.next = 5;
            break;
          }

          return _context2.abrupt('return');

        case 5:
          _context2.next = 7;
          return (0, _effects.call)(_sagaTools.fetchEntityIfNeeded, _bound.nearbyPopularVenues, [client, 0, {
            lat: location.lat,
            lon: location.lon,
            page_size: MAX_VENUES,
            page: 0,
            radius: radius
          }], { key: key });

        case 7:
          _ref3 = _context2.sent;
          venues = _ref3.venues;
          _context2.next = 11;
          return (0, _effects.call)(calculateBoundingBox, venues, { latitude: location.lat, longitude: location.lon });

        case 11:
          boundingBox = _context2.sent;

          if (!boundingBox) {
            _context2.next = 15;
            break;
          }

          _context2.next = 15;
          return (0, _effects.put)(_explore.setSnapLocation.apply(undefined, (0, _toConsumableArray3.default)(boundingBox.split(','))));

        case 15:
          validVenueCount = filterValidVenues(venues).length;

          if (!(validVenueCount < MIN_VENUES && !(0, _verify.isEmpty)(nextRadii))) {
            _context2.next = 21;
            break;
          }

          _context2.next = 19;
          return (0, _effects.put)(_bound.nearbyPopularVenues.resetAction({ key: key }));

        case 19:
          _context2.next = 21;
          return (0, _effects.call)(getNearbyPopularVenues, client, location, nextRadii);

        case 21:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function doLoadVenues(client, _ref4) {
  var lat = _ref4.lat,
      lon = _ref4.lon;
  return _regenerator2.default.wrap(function doLoadVenues$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.prev = 0;

          if (![lat, lon].some(_verify.isAbsent)) {
            _context3.next = 3;
            break;
          }

          return _context3.abrupt('return');

        case 3:
          _context3.next = 5;
          return (0, _effects.call)(getNearbyPopularVenues, client, { lat: lat, lon: lon });

        case 5:
          _context3.next = 11;
          break;

        case 7:
          _context3.prev = 7;
          _context3.t0 = _context3['catch'](0);
          _context3.next = 11;
          return (0, _effects.call)(logger.warn, 'ExploreMapV1: Failed while loading venues', _context3.t0);

        case 11:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this, [[0, 7]]);
}

function watchSaga(client) {
  return _regenerator2.default.wrap(function watchSaga$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.fork)(_effects.takeEvery, loadVenues().type, doLoadVenues, client);

        case 2:
          _context4.next = 4;
          return (0, _effects.fork)(_effects.takeEvery, ctaClick().type, doCtaNavigation, client);

        case 4:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}